import { Button } from 'react-bootstrap';
import RenderSortIcon from "Components/Datatable/RenderSortIcon";
import { TableIconTextButton } from 'Components/Button';
import ChevronLeft from '@mui/icons-material/Add';
import Download from '@mui/icons-material/FileDownloadOutlined';
import InfoFieldRow from './InfoFieldRow';

const InfoTable = ({data, colSizes}) => {
    const defColSizes = {
        label: {
            xl: 3,
            lg: 4,
            md: 4,
            sm: 4,
            xs: 5
        },
        value: {
            xl:9,
            lg:8,
            md:8,
            sm:8,
            xs:7
        }
        
    }

    return (
        <div className="info-container">
            {
                data.length !== 0 
                ?   data.map((values) => (
                        <InfoFieldRow name={values.name} value={values.value} colSizes={colSizes != null ? colSizes : defColSizes}></InfoFieldRow>
                    )) 
                :   
                null
            }
        </div>
    );
}

export default InfoTable; 